export default "__VITE_ASSET__BDMgKhix__"